export const url = "https://spicy-hall.onrender.com"